<modal>
  <div header class="uppercase flex space-between"><span>{{title}}</span><span media="print">{{now | date : 'dd-MM-yyyy HH:mm:ss z'}} ({{'hiển thị' | lang}} {{ details.matches.length + '/' + details.source.length }} {{'bảng ghi' | lang}})</span></div>
  
  <div media="screen" class="flex space-between std-border-top std-padding-top">

    <select [(ngModel)]="details" class="std-margin-bottom">
      <option [ngValue]="goods">{{'Nhóm theo mã hàng / mã màu' | lang}}</option>
      <option [ngValue]="sources">{{'Nhóm theo nguồn nhập hàng' | lang}}</option>
      <option [ngValue]="targets">{{'Nhóm theo khách mua cuối' | lang}}</option>
      <option [ngValue]="flows">{{'Nhóm theo đường nhập xuất' | lang}}</option>
      <option *ngIf="filters" [ngValue]="filtered">{{filterName}}</option>
    </select>

    <div class="flex std-margin-bottom">
      <text-filter [target]="details" [placeholder]="'Tìm kiếm'"></text-filter>
      <button class="std-margin-left text-white bg-primary pointer" (click)="print()"><i class="fa fa-print"></i></button>
      <button class="hlf-margin-left text-white bg-success pointer" (click)="exportExcel()"><i class="fa fa-file-excel"></i></button>
      <button class="hlf-margin-left text-white bg-warning pointer" (click)="copy()"><i class="fa fa-copy"></i></button>
    </div>
  </div>

  

  <table responsive class="data">
    <tr>
      <th priority="11" class="text-top text-right" style="width: 0">{{'STT' | lang}}</th>
      <th priority="1" class="text-top"><sortable [target]="details" [extractor]="extractor('SKU')">{{'Mã hàng' | lang}}</sortable></th>
      <th priority="8" class="text-center text-top"><sortable [target]="details" [extractor]="extractor('Color')">{{'Màu' | lang}}</sortable></th>
      <th priority="3" class="text-center text-top"><sortable [target]="details" [extractor]="extractor('Quantity')">{{'Số cây' | lang}}</sortable></th>
      <th priority="9" class="text-top">{{'Mét / cân từng cây' | lang}}</th>
      <th priority="5" class="text-right text-bottom"><sortable [target]="details" [extractor]="extractor('ActualQuantity')">{{'Tổng dài / nặng' | lang}}</sortable></th>
      <th priority="5" class="text-right text-bottom"><sortable [target]="details" [extractor]="extractor('ReducedQuantity')">{{'Khấu trừ' | lang}}</sortable></th>
      <th priority="4" class="text-right text-bottom"><sortable [target]="details" [extractor]="extractor('QuoteQuantity')">{{'Tính tiền' | lang}}</sortable></th>
      <th priority="6" class="text-right text-bottom"><sortable [target]="details" [extractor]="extractor('Price')">{{'Giá' | lang}}</sortable></th>
      <th priority="2" class="text-right text-bottom"><sortable [target]="details" [extractor]="extractor('Subtotal')">{{'Thành tiền' | lang}}</sortable></th>
      <th priority="7" class="text-center text-bottom whitesmoke" *ngIf="details == sources || details == flows || details == filtered"><sortable [target]="details" [extractor]="extractor('Vendor')">{{'Nhập từ' | lang}}</sortable></th>
      <th priority="10" class="text-center text-bottom whitesmoke" *ngIf="details == sources || details == flows || details == filtered"><sortable [target]="details" [extractor]="extractor('ImportTag')">{{'Đơn nhập' | lang}}</sortable></th>
      <th priority="7" class="text-center text-bottom whitesmoke" *ngIf="details == targets || details == flows || details == filtered"><sortable [target]="details" [extractor]="extractor('Customer')">{{'Xuất tới' | lang}}</sortable></th>
      <th priority="10" class="text-center text-bottom whitesmoke" *ngIf="details == targets || details == flows || details == filtered"><sortable [target]="details" [extractor]="extractor('ExportTag')">{{'Đơn xuất' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of details.matches; index as ix">
      <td><small>{{ix + 1}}</small></td>
      <td>
        <good class="bold text-primary spacy nowrap" [sku]="i.SKU"></good>
      </td>
      <td class="bold text-info">{{i.Color}}</td>
      <td class="bold">{{i.Count}}</td>
      <td>
        <div class="flex length">
          <span *ngFor="let x of i.Quantities" [ngClass]="{'text-success': !x.Returned && x.Exported, 'text-danger': !x.Returned && !x.Exported, 'text-warning': x.Returned}">{{x.Quantity | number : '1.0-1' : 'en-US'}}<small class="nowrap text-danger hlf-margin-left" *ngIf="x.Discount > 0">- {{x.Discount | number : '1.0-1' : 'en-US'}}</small></span>
        </div>
      </td>
      <td><b class="text-info">{{i.ActualQuantity | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit></td>
      <td><b class="text-danger">{{i.ReducedQuantity | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit></td>
      <td><b class="text-primary">{{i.QuoteQuantity | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit></td>
      <td><b class="text-info">{{i.Price | number : '1.0-1' : 'en-US'}}</b><symbol-per-unit [symbol]="invoice.Icon" [type]="i.Unit"></symbol-per-unit></td>
      <td><b class="text-primary">{{i.Subtotal | number : '1.0-1' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">{{invoice.Icon}}</span></td>
      <td *ngIf="details == sources || details == flows || details == filtered">
        <span class="small bold spacy uppercase nowrap">{{name(i.ImportTag)}}</span>
      </td>
      <td *ngIf="details == sources || details == flows || details == filtered">
        <invoice class="small" [tag]="i.ImportTag" [displays]="{}" [openable]="i.ImportTag != invoice.Tag" [filters]="{sku: i.SKU, color: i.Color, exportTag: i.ExportTag }"></invoice>        
      </td>
      <td *ngIf="details == targets || details == flows || details == filtered">
        <span class="small bold spacy uppercase nowrap">{{name(i.ExportTag)}}</span>
      </td>
      <td *ngIf="details == targets || details == flows || details == filtered">
        <invoice class="small" [tag]="i.ExportTag" [displays]="{}" [openable]="i.ExportTag != invoice.Tag" [filters]="{sku: i.SKU, color: i.Color, importTag: i.ImportTag }"></invoice>
      </td>
    </tr>
    <tr *ngIf="sum('Count', 1) * sum('Count', 2) > 0" class="nowrap">
      <td></td>
      <td class="bold">
        <div>{{'TỔNG MÉT' | lang}}</div>
        <div>{{'TỔNG CÂN' | lang}}</div>
      </td>
      <td></td>
      <td class="bold">
        <div>{{sum('Count', 1)}}</div>
        <div>{{sum('Count', 2)}}</div>
      </td>
      <td></td>
      <td>
        <div><b>{{sum('ActualQuantity', 1) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="1"></product-unit></div>
        <div><b>{{sum('ActualQuantity', 2) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="2"></product-unit></div>
      </td>
      <td>
        <div><b>{{sum('ReducedQuantity', 1) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="1"></product-unit></div>
        <div><b>{{sum('ReducedQuantity', 2) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="2"></product-unit></div>
      </td>
      <td>
        <div><b>{{sum('QuoteQuantity', 1) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="1"></product-unit></div>
        <div><b>{{sum('QuoteQuantity', 2) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="2"></product-unit></div>
      </td>
      <td></td>
      <td>
        <div><b>{{sum('Subtotal', 1) | number : '1.0-1' : 'en-US'}}</b><unit>{{invoice.Icon}}</unit></div>
        <div><b>{{sum('Subtotal', 2) | number : '1.0-1' : 'en-US'}}</b><unit>{{invoice.Icon}}</unit></div>
      </td>
      <td *ngIf="details == sources || details == flows || details == filtered" class="whitesmoke"></td>
      <td *ngIf="details == targets || details == flows || details == filtered" class="whitesmoke"></td>
      <td *ngIf="details == sources || details == flows || details == filtered" class="whitesmoke"></td>
      <td *ngIf="details == targets || details == flows || details == filtered" class="whitesmoke"></td>
    </tr>
    <tr class="footer text-primary" *ngIf="details.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG ĐƠN' | lang}}</td>
      <td></td>
      <td><b>{{sum('Count')}}</b></td>
      <td></td>
      <td>
        
          <b>{{sum('ActualQuantity') | number : '1.1-1' : 'en-US'}}</b>
          <m *ngIf="sum('Count', 2) < 1 && sum('Count', 1) > 0"></m>
          <kg *ngIf="sum('Count', 1) < 1 && sum('Count', 2) > 0"></kg>
          <unit *ngIf="sum('Count', 1) * sum('Count', 2) > 0">đv</unit>
        
      </td>
      <td>
        <b>{{sum('ReducedQuantity') | number : '1.1-1' : 'en-US'}}</b>
        <m *ngIf="sum('Count', 2) < 1 && sum('Count', 1) > 0"></m>
        <kg *ngIf="sum('Count', 1) < 1 && sum('Count', 2) > 0"></kg>
        <unit *ngIf="sum('Count', 1) * sum('Count', 2) > 0">đv</unit>
      </td>
      <td>
        <b>{{sum('QuoteQuantity') | number : '1.1-1' : 'en-US'}}</b>
        <m *ngIf="sum('Count', 2) < 1 && sum('Count', 1) > 0"></m>
        <kg *ngIf="sum('Count', 1) < 1 && sum('Count', 2) > 0"></kg>
        <unit *ngIf="sum('Count', 1) * sum('Count', 2) > 0">đv</unit>
      </td>
      <td></td>
      <td><b>{{sum('Subtotal') | number : '1.0-2' : 'en-US'}}</b><unit>{{invoice.Icon}}</unit></td>
      <td *ngIf="details == sources || details == flows || details == filtered" class="whitesmoke"></td>
      <td *ngIf="details == targets || details == flows || details == filtered" class="whitesmoke"></td>
      <td *ngIf="details == sources || details == flows || details == filtered" class="whitesmoke"></td>
      <td *ngIf="details == targets || details == flows || details == filtered" class="whitesmoke"></td>
    </tr>
  </table>

  <collapsible *ngIf="payments.length > 0" class="std-margin-bottom">
    <div header class="uppercase">{{'Lịch sử thanh toán' | lang}}</div>
    <table responsive class="data">
      <tr>
        <th>Ngày</th>
        <th>Mã thanh toán</th>
        <th class="text-right">Số tiền</th>
      </tr>
      <tr *ngFor="let i of payments">
        <td class="bold">{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
        <td class="text-primary bold spacy">{{i.Tag}}</td>
        <td>
          <span [ngClass]="{'text-danger': invoice.Type == 1, 'text-success': invoice.Type == 2}">{{i.Amount | number : '1.0-1' : 'en-US'}}</span>
          <vnd *ngIf="invoice.Symbol == 'VND'"></vnd>
          <cny *ngIf="invoice.Symbol == 'CNY'"></cny>
        </td>
      </tr>
      <tr class="footer bold" *ngIf="payments.length > 1">
        <td>{{'TỔNG' | lang}}</td>
        <td></td>
        <td>
          <span [ngClass]="{'text-danger': invoice.Type == 1, 'text-success': invoice.Type == 2}">{{paid | number : '1.0-1' : 'en-US'}}</span>
          <vnd *ngIf="invoice.Symbol == 'VND'"></vnd>
          <cny *ngIf="invoice.Symbol == 'CNY'"></cny>
        </td>
      </tr>
      <tr class="bold">
        <td class="text-primary">{{'CÒN LẠI' | lang}}</td>
        <td></td>
        <td>
          <span class="text-primary">{{invoice.Total - paid | number : '1.0-1' : 'en-US'}}</span>
          <vnd *ngIf="invoice.Symbol == 'VND'"></vnd>
          <cny *ngIf="invoice.Symbol == 'CNY'"></cny>
        </td>
      </tr>
    </table>

  </collapsible>

  <button *ngIf="unconfirmable && details != filtered" class="bg-danger text-white w-100 pointer std-margin-top" (click)="unconfirm()"><span>{{'Mở lại đơn hàng' | lang}}</span></button>
</modal>

<ngx-loading [show]="loading" [config]="{fullscreenBackdrop: true}"></ngx-loading>
